// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles'; // Keep these imports
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SnackbarProvider } from 'notistack'; // <-- Import SnackbarProvider

// --- Define the enhanced dark theme ---
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      // Keeping the vibrant blue for primary actions unless specified otherwise
      main: '#29b6f6', // Light Blue A200
      light: '#4fc3f7',
      dark: '#0288d1',
      contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    secondary: {
      // Using your third color (orange/gold) for secondary accents
      main: '#e39f1a', // Your third color
      light: '#e9ae40', // Slightly lighter version
      dark: '#c08516', // Slightly darker version
      contrastText: 'rgba(0, 0, 0, 0.87)', // Black text should contrast well
    },
    background: {
      default: '#35383d', // Your main color
      paper: '#445364',   // Your secondary color
    },
    text: {
      primary: '#e8e8e8', // Slightly adjusted light grey for primary text
      secondary: '#b0bec5', // Keeping Blue Grey 200 for secondary text
    },
  },
  typography: {
    // Optional: Customize fonts if desired
    // fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    // ... other typography settings
  },
  components: {
    // Optional: Default styles for components
    MuiAppBar: {
      styleOverrides: {
        root: ({ theme }) => ({
          // Example: Add a subtle gradient to all AppBars (using primary color)
          background: `linear-gradient(90deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
          boxShadow: '0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12)', // Keep or enhance shadow
        }),
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '16px', // Slightly rounded buttons by default
          textTransform: 'none', // Default to non-uppercase
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
        }
      }
    }
    // You might want to adjust component overrides if they relied heavily
    // on the previous theme's specific colors (e.g., background.paper)
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* --- Use the enhanced darkTheme --- */}
    <ThemeProvider theme={darkTheme}>
      <CssBaseline /> {/* CssBaseline adapts to the theme mode */}
      {/* Wrap App with SnackbarProvider */}
      <SnackbarProvider
        maxSnack={3} // Max number of snackbars displayed at once
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        autoHideDuration={4000} // Default duration in ms
      >
        <App />
      </SnackbarProvider>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
